var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavBtnAudioOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0143 3.14056V13.7912H12.0214V3.14056H14.0143ZM5.97857 3.14056V13.7912H3.98571V3.14056H5.97857ZM1.99286 6.3494V10.5823H0V6.3494H1.99286ZM18 6.3494V10.5823H16.0071V6.3494H18ZM10.0286 0V17H8.03571V0H10.0286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBtnAudioOn);
export default __webpack_public_path__ + "static/media/nav_btn_audio_on.1f9f099096bbfa785fc8bae1f1910ff6.svg";
export { ForwardRef as ReactComponent };